import React, { useRef, useState, useEffect } from "react";
import { RegisterStatus, CONNECT_STATUS, useSIPProvider } from "react-sipjs";
import { CallSessionItem } from "./CallSessionItem";
import { dispatch } from "store/index";
import { AddCallLog } from "store/action/index";

export const CallSip = ({ username, password, callTo, currentLead, allData, setLeadFieldDisabledCond }) => {
    const [isAudioPlaying, setIsAudioPlaying] = useState(false);
    const [callInProgress, setCallInProgress] = useState(false);
    const audioRef = useRef(null);
    const establishedAudioRef = useRef(null); // New ref for "call established" sound
    const terminatedAudioRef = useRef(null); // New ref for "call terminated" sound

    const {
        connectAndRegister,
        sessionManager,
        sessions,
        registerStatus,
        connectStatus,
    } = useSIPProvider();

    useEffect(() => {
        connectAndRegister({
            username: username,
            password: password,
        });
    }, [username, password])

    function formatEDate(date) {
        if (!date) return '';

        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');

        let hours = d.getHours();
        const minutes = String(d.getMinutes()).padStart(2, '0');
        const seconds = String(d.getSeconds()).padStart(2, '0');

        hours = hours % 12;
        hours = hours ? hours : 12; // midnight ko 12 banaye

        hours = String(hours).padStart(2, '0');

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }

    const formatYDate = (date) => {
        if (!date) return '';

        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        let hours = d.getHours();
        const minutes = String(d.getMinutes()).padStart(2, '0');
        const seconds = String(d.getSeconds()).padStart(2, '0');

        hours = hours % 12;
        hours = hours ? hours : 12; // hour '0' should be '12'
        hours = String(hours).padStart(2, '0');

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };

    const handleStartCall = (status, duration, answerAt, download_path) => {
        const validTimestamp = answerAt && !isNaN(new Date(answerAt).getTime());
        const payload = {
            "lead_id": currentLead?.lead?.id,
            "call_started_on": validTimestamp
                ? formatYDate(answerAt)
                : formatEDate(new Date()),
            "call_ended_on": status == 'Terminated' ? formatEDate(new Date()) : null,
            "call_status": status == 'Established' ? 'Established' : status == 'Terminated' ? 'Terminated' : "Calling",
            "call_duration": duration ? duration : null,
            "activity_history_id": currentLead?.id,
            "current_activity_id": allData?.id,
            "download_path": download_path || ""
        };
        if (status === "start_calling" && !isAudioPlaying) {
            audioRef.current.play();  // Play the audio
            setIsAudioPlaying(true);  // Update the state to track that audio is playing
            setCallInProgress(true); // disable button
        }

        if (status === "Terminated") {
            setCallInProgress(false); // re-enable button
            terminatedAudioRef.current.play(); // Play the termination sound
        }

        if (status == "Established") {
            establishedAudioRef.current.play(); // Play the established call sound
            setLeadFieldDisabledCond(false)
        }
        // If call is terminated or established, stop the audio
        if (status === "Terminated" || status === "Established") {
            audioRef.current.pause();  // Pause the audio
            audioRef.current.currentTime = 0;  // Reset audio to the beginning
            setIsAudioPlaying(false);  // Update state to reflect that audio has stopped
        }
        let params = { team_id: localStorage.getItem("teams_id") }

        // Dispatch the payload
        dispatch(AddCallLog({ fieldData: payload, status: status, params: params }));
    }
    return (
        <div className="d-flex justify-content-center">
            <div className="min-w-700px d-flex flex-column gap-3">
                <div>
                    <audio ref={audioRef} style={{ display: "none" }} loop>
                        <source
                            src={require("../../assets/phonering_x9.mp3")}
                            type="audio/mp3"
                        />
                    </audio>
                    <audio ref={establishedAudioRef} style={{ display: "none" }}>
                        <source src={require("../../assets/phone-call-14472.mp3")} type="audio/mp3" />
                    </audio>
                    <audio ref={terminatedAudioRef} style={{ display: "none" }}>
                        <source src={require("../../assets/end-call-120633.mp3")} type="audio/mp3" />
                    </audio>
                    <form
                        onSubmit={(e) => {
                            e.preventDefault();
                            // connectAndRegister({
                            //     username: username,
                            //     password: password,
                            // });
                        }}
                    >
                        <div className="d-flex flex-column gap-3">

                            {/* {connectStatus !== CONNECT_STATUS.CONNECTED ? (
                                <button
                                    type="submit"
                                    className="btn btn-outline-primary btn-sm"
                                >
                                    Connect
                                </button>
                            ) : (
                                <button
                                    type="button"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        sessionManager?.disconnect();
                                    }}
                                    className="btn btn-outline-danger btn-sm"
                                >
                                    Disconnect
                                </button>
                            )} */}
                        </div>
                    </form>
                </div>
                <div>
                    <div className="mt-2 d-flex align-items-center gap-2">
                        <div
                            className={`rounded-circle p-1 ${connectStatus === CONNECT_STATUS.CONNECTED ? "bg-success" : "bg-warning"}`}
                        >
                            <div className={`rounded-circle ${connectStatus === CONNECT_STATUS.CONNECTED ? "bg-success" : "bg-warning"}`} style={{ height: '5px', width: '5px' }}></div>
                        </div>
                        <p className="small text-muted mb-0">
                            Connect Status: {connectStatus}
                        </p>
                    </div>
                    <div className="mt-2 d-flex align-items-center gap-2">
                        <div
                            className={`rounded-circle p-1 ${registerStatus === RegisterStatus.REGISTERED ? "bg-success" : "bg-warning"}`}
                        >
                            <div className={`rounded-circle ${registerStatus === RegisterStatus.REGISTERED ? "bg-success" : "bg-warning"}`} style={{ height: '5px', width: '5px' }}></div>
                        </div>
                        <p className="small text-muted mb-0">
                            Register Status: {registerStatus}
                        </p>
                    </div>
                </div>

                <form>
                    <div className="d-flex flex-column gap-3">
                        {/* <label>Make the new call</label>
                        <input
                            value={callTo}
                            type="text"
                            className="form-control"
                            disabled
                        /> */}

                        <button disabled={callInProgress}
                            onClick={async (e) => {
                                e.preventDefault();
                                const options = {
                                    media: {
                                        constraints: { audio: true, video: false }, // Specify audio only
                                        codecPreferences: ["audio/PCMU", "audio/PCMA"], // ulaw (PCMU) and alaw (PCMA)
                                    },
                                };
                                await sessionManager?.call(
                                    `sip:${callTo}@${allData?.call_provider?.domain}`,
                                    options
                                );
                                handleStartCall("start_calling")
                            }}
                            className="btn btn-outline-primary btn-sm"
                        >
                            Call
                        </button>
                    </div>
                </form>
                <div className="d-flex flex-1 justify-content-center">
                    <ul className="list-unstyled">
                        {Object.keys(sessions).at(-1) && (
                            <CallSessionItem key={Object.keys(sessions).at(-1)} sessionId={Object.keys(sessions).at(-1)} handleStartCall={handleStartCall} />
                        )}
                    </ul>
                </div>
            </div>
        </div>
    );
};
